module.exports = __webpack_public_path__ + "media/images/checkmark-a6c55b4d1b3ef277dee09bb329bfada2.svg";